var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('talent-info',{attrs:{"row":_vm.row}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }